import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative pt-10 pb-12 overflow-hidden" style={{
    background: 'linear-gradient(180deg, var(--color-sky-light) 0%, var(--color-cream) 100%)'
  }} data-id="element-122">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden" data-id="element-123">
        <div className="absolute top-[-15%] right-[-10%] w-[35%] h-[35%] rounded-full opacity-40 blur-3xl" style={{
        backgroundColor: 'var(--color-sky-mid)'
      }} data-id="element-124" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[25%] h-[25%] rounded-full opacity-30 blur-3xl" style={{
        backgroundColor: 'var(--color-cream-warm)'
      }} data-id="element-125" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-126">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-127">
          {/* Digital Badge */}
          <FadeIn delay={0.05} data-id="element-128">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/80 backdrop-blur-sm border mb-5 shadow-sm" style={{
            borderColor: 'var(--color-border)'
          }} data-id="element-129">
              <span className="text-sm font-bold" style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-130">
                📲 Producto 100% digital · Descarga inmediata
              </span>
            </div>
          </FadeIn>

          {/* Stars */}
          <FadeIn delay={0.1} data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/jtUjL2iSAzZimTv3YjW3ws/Diseno_sin_titulo.png" alt="Valoraciones de 5 estrellas" className="h-12 object-contain opacity-90 mb-4" data-id="element-132" />
          </FadeIn>

          {/* Headline */}
          <FadeIn delay={0.15} data-id="element-133">
            <h1 className="text-3xl md:text-5xl font-extrabold mb-4 max-w-4xl mx-auto leading-tight" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-134">
              ¿Tus hijos pasan demasiado tiempo frente a las pantallas?
            </h1>
          </FadeIn>

          {/* Subheadline */}
          <FadeIn delay={0.2} data-id="element-135">
            <p className="text-xl md:text-2xl font-bold mb-4 max-w-3xl mx-auto" style={{
            color: 'var(--color-gold)'
          }} data-id="element-136">
              Descubrí una colección cristiana completa con +500 parábolas,
              devocionales, juegos y actividades listas para usar
            </p>
          </FadeIn>

          {/* Reinforcement */}
          <FadeIn delay={0.25} data-id="element-137">
            <p className="text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto font-medium" style={{
            color: 'var(--color-body)'
          }} data-id="element-138">
              Todo lo que necesitás para enseñar sobre Dios de forma atractiva,
              práctica y amorosa — en un solo pack digital.
            </p>
          </FadeIn>

          {/* Mockup */}
          <FadeIn delay={0.3} className="w-full" data-id="element-139">
            <div className="relative max-w-4xl w-full mx-auto mb-10" data-id="element-140">
              <div className="absolute inset-0 rounded-full blur-3xl opacity-40 scale-105" style={{
              backgroundColor: 'var(--color-gold)'
            }} data-id="element-141" />
              <img src="https://cdn.magicpatterns.com/uploads/ttVM6rGpKjWu244an5Xj1i/MOCK_UP.png" alt="Colección Pequeños Amigos de Dios - Vista completa" className="relative w-full h-auto rounded-2xl shadow-2xl" data-id="element-142" />
            </div>
          </FadeIn>

          {/* CTAs */}
          <FadeIn delay={0.35} className="flex flex-col items-center w-full max-w-md mx-auto gap-4" data-id="element-143">
            <a href="#comprar" className="w-full inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white rounded-full transition-all duration-300 hover:-translate-y-1" style={{
            backgroundColor: 'var(--color-gold)',
            boxShadow: '0 4px 20px rgba(201,150,59,0.4)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold-hover)';
            e.currentTarget.style.boxShadow = '0 6px 25px rgba(201,150,59,0.5)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(201,150,59,0.4)';
          }} data-id="element-144">
              QUIERO LA COLECCIÓN COMPLETA
            </a>

            <p className="mt-2 font-medium text-sm" style={{
            color: 'var(--color-body)'
          }} data-id="element-145">
              Elegida por más de 400 familias · Acceso inmediato
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}